import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import PALETTE_SCHEMA from './menus-links-lists.palette-schema.yaml';

class MenusLinksListsFeature extends AbstractVisualFeature {
    get name() {
        return 'MenusLinksLists';
    }
    get paletteSchema() {
        return PALETTE_SCHEMA;
    }
}

export const MenusLinksLists = new MenusLinksListsFeature(allVisuals);
